import { createGlobalStyle } from "styled-components";

const Styles = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-size: 16px;
    font-family: "Inter", sans-serif;
  }

  .app{
    .menu{
      display: flex;
      width: 250px;
      transition: 600ms;
    }
    .layout:has(.close){
      grid-template-columns: 50px auto;
      
      .menu{
        width: 50px;
      }
      .MC{
        width: calc(100vw - 50px - 20px);
      }
    } 
  }

  a{
    text-decoration: none;
  }
  button{
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
  li,ul{
    list-style: none;
  }
  html, body{
    max-width: 100vw;
    overflow-x: hidden;
    background-color:#e6e6e6;
  }

  #root{
    --dark-green:#00552c;
    --main-green: #008B47;
    --light-green: #3cff96;
    --very_light-green:#94bda7;

    --main-blue: #004da2;
    --dark-blue: #013876;
    --darkest-blue: #001d3f;

    --main-height: calc(100vh - (115.54px + 230px));
  }
`;
export default Styles;
